export const defaultAuthState = {
  userInfo: {},
  tokenType: null,
  mtaxAccessToken: null,
  jPAccessToken: null,
  jPExpire: null,
  jPrefreshToken: null,
  mTaxExpire: null,
  startDate: null,
  misaAccessToken: null,
  misaExpire: null,
  misaRefreshToken: null,
  EmailActive: false,
  PhoneActive: false,
  isLater: false,
  timeOut: 0,
  LinkSignalR: null,
  RunSignalR: false,
  RoleLocal: [],
};

export default {
  ...defaultAuthState,
};
